import { NavLink } from "react-router-dom";
import { useState } from "react";
import { MdDashboard } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import pro from "../../assets/profile.svg";
import { useAuth } from "../../context/useAuth";

export default function Sidebar() {
  const { logout } = useAuth();
  

  const navLinkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-[10px] transition-all text-sm font-medium ${
      isActive
        ? "bg-orange-100 text-orange-600 font-semibold"
        : "text-gray-700 hover:bg-orange-50 hover:text-orange-600"
    }`;

  return (
    <div className="w-[297px] h-screen fixed top-0 left-0 bg-white p-8 flex flex-col justify-between shadow-lg border-r border-gray-200 z-50">
      <div>
        <div className="w-full mb-5">
          <h1 className="text-orange-500 font-[700] text-[25px]">
            Sweetplate Admin
          </h1>
        </div>

        <nav className="flex flex-col gap-3">
          <NavLink to="/dashboard" className={navLinkClasses}>
            <MdDashboard size={20} /> Dashboard
          </NavLink>

          <NavLink to="/dashboard/orders" className={navLinkClasses}>
            <span className="ml-1">Orders</span>
          </NavLink>

          <NavLink to="/dashboard/vendors" className={navLinkClasses}>
            <span className="ml-1">Vendors</span>
          </NavLink>

          <NavLink to="/dashboard/riders" className={navLinkClasses}>
            <span className="ml-1">Riders</span>
          </NavLink>

          <NavLink to="/dashboard/locations" className={navLinkClasses}>
            <span className="ml-1">Locations</span>
          </NavLink>

          <NavLink to="/dashboard/categories" className={navLinkClasses}>
            <span className="ml-1">Categoris</span>
          </NavLink>

          <NavLink to="/dashboard/products" className={navLinkClasses}>
            <span className="ml-1">Products</span>
          </NavLink>
        </nav>
      </div>

      <div className="pt-4 mb-10">
        <div className="flex items-center gap-4">
          <div className="h-[56px] w-[56px] rounded-full overflow-hidden border border-gray-300">
            <img
              src={pro}
              alt="profile"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="flex-1">
            <h1 className="text-sm font-semibold text-gray-800">Admin</h1>
            <div className="flex items-center justify-between text-xs text-gray-500">
              <p>admin@sweetplate.org</p>
              <button onClick={logout}>
                <CiLogout
                  className="text-red-600 hover:text-red-800 cursor-pointer"
                  size={20}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
